// @flow

export const EDUCATIONS_REQUEST = 'EDUCATIONS_REQUEST';
export const EDUCATIONS_REQUESTED = 'EDUCATIONS_REQUESTED';
export const EDUCATIONS_REQUESTED_ERROR = 'EDUCATIONS_REQUESTED_ERROR';

export const EDUCATION_CREATE = 'EDUCATION_CREATE';
export const EDUCATION_CREATED = 'EDUCATION_CREATED';
export const EDUCATION_CREATED_ERROR = 'EDUCATION_CREATED_ERROR';

export const EDUCATION_UPDATE = 'EDUCATION_UPDATE';
export const EDUCATION_UPDATED = 'EDUCATION_UPDATED';
export const EDUCATION_UPDATED_ERROR = 'EDUCATION_UPDATED_ERROR';

export const EDUCATION_DELETE = 'EDUCATION_DELETE';
export const EDUCATION_DELETED = 'EDUCATION_DELETED';
export const EDUCATION_DELETED_ERROR = 'EDUCATION_DELETED_ERROR';

export const EDUCATION_RESET = 'EDUCATION_RESET';
